import {
	SET_AP_STATUS,
	SET_SWITCH_STATUS,
	SET_GROUP_STATUS,
	SET_ALARM_STATUS,
	SET_CLIENT_STATUS,
	SET_SWITCH_ALARM_STATUS,
    SET_RADIO_STATUS,
	SET_SUB_SITE_STATUS,
	SET_SSID_STATUS,
	SWITCH_STATUS_CHANGE
} from '../constants/scrollExpandListViewConstants';

const initialState = {
	apStatus: null, // Store status (1 for online, 0 for offline)
	switchStatus: null,
	switchStatusClicked: false,
	groupStatus: null,
	alarmStatus: null,
	clientStatus: null,
	swithAlaramStatus: null,
	subSiteStatus: null,
	ssidStatus: null,
};

export const apStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_AP_STATUS:
			return {
				...state,
				apStatus: action.payload, // Update apStatus
			};
		default:
			return state;
	}
};

export const switchStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SWITCH_STATUS:
			return {
				...state,
				switchStatus: action.payload,
			};
		case SWITCH_STATUS_CHANGE:
			return {
				...state,
				switchStatusClicked: !state.switchStatusClicked,
			};
		default:
			return state;
	}
};

export const radioStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_RADIO_STATUS:
			return {
				...state,
				radioStatus: action.payload,
			};
		default:
			return state;
	}
};

export const groupStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_GROUP_STATUS:
			return {
				...state,
				groupStatus: action.payload,
			};
		default:
			return state;
	}
};

export const alarmStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_ALARM_STATUS:
			return {
				...state,
				alarmStatus: action.payload,
			};
		default:
			return state;
	}
};

export const clientStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CLIENT_STATUS:
			return {
				...state,
				clientStatus: action.payload,
			};
		default:
			return state;
	}
};

export const switchAlarmStatus = (state = initialState, action) => {
	switch (action.type) {
		case SET_SWITCH_ALARM_STATUS:
			return {
				...state,
				swithAlaramStatus: action.payload,
			};
		default:
			return state;
	}
};

export const subSiteStatusReducer = (state = initialState, action) => {
	switch (action.type){
		case SET_SUB_SITE_STATUS:
			return {
				...state,
				subSiteStatus: action.payload,
			};
		default:
			return state;
	}
}

export const ssidStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SSID_STATUS:
			return {
				...state,
				ssidStatus: action.payload,
			};
		default:
			return state;
	}
};